import React from "react";

// ============================================================
// ▾ KHỐI THU GỌN
// ------------------------------------------------------------
// Ở Đợt N1, khối này CỐ Ý không được đưa vào bộ vỏ. Lý do ghi trong
// `vo/index.js` lúc đó:
//
//   "Khối thu gọn đang tồn tại ĐÚNG MỘT chỗ, trong ViecNha.js. Gom vào đây
//    là xây cho một tương lai chưa chắc tới. Khi nào có chỗ thứ hai cần nó
//    thì mới chuyển sang đây — lúc đó mới biết hai chỗ giống nhau ở đâu."
//
// Đợt N2 có chỗ thứ hai: trang Lịch cần thu gọn phần "đã qua". Hai chỗ dùng
// đúng cùng một hình dạng (tiêu đề bấm được · đếm số · ghi chú · danh sách),
// nên nay chuyển sang đây theo đúng điều kiện đã đặt ra.
//
// Ghi lại chuyện này vì nó là ví dụ cho cách làm việc muốn giữ: **không gom
// theo dự đoán, gom khi đếm được**.
//
// ⚠️ Phải nằm ở module riêng, không lồng trong component cha — hàm lồng
// trong hàm thì mỗi lần vẽ lại là một hàm mới, React tháo hẳn cây cũ ra dựng
// lại, làm mất con trỏ trong ô nhập. Xem docs/bai-hoc/…06_ham-trong-ham….
// ============================================================

/**
 * @param {string}   tieuDe    tiêu đề, sẽ tự kèm "(số lượng)"
 * @param {string}   [ghiChu]  câu giải thích, chỉ hiện khi đang mở
 * @param {Array}    ds        danh sách. RỖNG thì cả khối tự ẩn
 * @param {Function} veDong    hàm vẽ một dòng
 * @param {boolean}  mo        đang mở hay đóng
 * @param {Function} onDoiMo   bấm vào tiêu đề
 */
export default function KhoiGon({ tieuDe, ghiChu, ds, veDong, mo, onDoiMo }) {
  if (ds.length === 0) return null;
  return (
    <div className="viec-khoi viec-khoi-phu">
      <h4 className="viec-khoi-gon" onClick={onDoiMo}>
        {tieuDe} ({ds.length}) {mo ? "⬆" : "⬇"}
      </h4>
      {mo && (
        <>
          {ghiChu && <p className="viec-khoi-ghi-chu">{ghiChu}</p>}
          <ul className="list">{ds.map(veDong)}</ul>
        </>
      )}
    </div>
  );
}
